import React from 'react';
import './Team.css';

const team = [
  {
    name: 'Aryan Sharma',
    role: 'Founder & Chief Architect',
    rank: 'COMMANDER',
    spec: 'AI Strategy · System Architecture',
    avatar: 'AS',
    color: '#00d4ff',
    socials: { github: '#', linkedin: '#', twitter: '#' },
  },
  {
    name: 'Priya Nair',
    role: 'Head of AI Research',
    rank: 'CAPTAIN',
    spec: 'Deep Learning · NLP · MLOps',
    avatar: 'PN',
    color: '#7b2fff',
    socials: { github: '#', linkedin: '#', twitter: '#' },
  },
  {
    name: 'Rohan Mehta',
    role: 'Lead Web Engineer',
    rank: 'LIEUTENANT',
    spec: 'React · Node.js · Cloud',
    avatar: 'RM',
    color: '#ffd700',
    socials: { github: '#', linkedin: '#', twitter: '#' },
  },
  {
    name: 'Sara Khan',
    role: 'Mobile Commander',
    rank: 'LIEUTENANT',
    spec: 'React Native · Flutter · iOS',
    avatar: 'SK',
    color: '#00d4ff',
    socials: { github: '#', linkedin: '#', twitter: '#' },
  },
  {
    name: 'Dev Patel',
    role: 'UI/UX Architect',
    rank: 'SPECIALIST',
    spec: 'Design Systems · Motion · UX',
    avatar: 'DP',
    color: '#7b2fff',
    socials: { github: '#', linkedin: '#', twitter: '#' },
  },
  {
    name: 'Neha Singh',
    role: 'DevOps & Cloud Engineer',
    rank: 'SPECIALIST',
    spec: 'AWS · Kubernetes · CI/CD',
    avatar: 'NS',
    color: '#ffd700',
    socials: { github: '#', linkedin: '#', twitter: '#' },
  },
];

function Avatar({ initials, color }) {
  return (
    <div className="team-avatar" style={{ '--avatar-color': color }}>
      <span>{initials}</span>
      <div className="avatar-ring" />
    </div>
  );
}

export default function Team() {
  return (
    <section className="team section" id="team">
      <div className="grid-bg" />

      {/* background decoration */}
      <div className="team-bg-orb team-orb-1" />
      <div className="team-bg-orb team-orb-2" />

      <div className="container">
        <div className="team-header">
          <div>
            <span className="section-tag">The Clan</span>
            <h2 className="section-title">
              MEET THE <span className="gradient-text">COMMANDERS</span>
            </h2>
          </div>
          <p className="team-intro">
            Every member of BlueClan is handpicked — elite engineers who have proven their
            skill in the harshest production environments.
          </p>
        </div>

        <div className="team-grid">
          {team.map((member, i) => (
            <div className="team-card glass-card" key={member.name} style={{ '--member-color': member.color, animationDelay: `${i * 0.1}s` }}>
              <div className="team-card-inner">
                <div className="team-rank-badge">
                  <span className="rank-line" />{member.rank}<span className="rank-line" />
                </div>

                <Avatar initials={member.avatar} color={member.color} />

                <h3 className="member-name">{member.name}</h3>
                <div className="member-role">{member.role}</div>
                <div className="member-spec">
                  <span className="spec-dot">◆</span> {member.spec}
                </div>

                <div className="member-socials">
                  <a href={member.socials.github} className="social-btn" aria-label="GitHub">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                      <path d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2z"/>
                    </svg>
                  </a>
                  <a href={member.socials.linkedin} className="social-btn" aria-label="LinkedIn">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/>
                      <circle cx="4" cy="4" r="2"/>
                    </svg>
                  </a>
                  <a href={member.socials.twitter} className="social-btn" aria-label="Twitter">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                      <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"/>
                    </svg>
                  </a>
                </div>
              </div>

              <div className="member-glow" style={{ background: member.color }} />
            </div>
          ))}
        </div>

        {/* Join CTA */}
        <div className="team-join glass-card">
          <div className="join-content">
            <span className="join-tag">We're Recruiting</span>
            <h3 className="join-title">Think You Have What It Takes?</h3>
            <p className="join-desc">
              BlueClan only accepts the best. If you're an elite engineer who lives and breathes
              technology, we want to hear from you.
            </p>
          </div>
          <div className="join-actions">
            <a href="#contact" className="btn-primary"><span>Apply to the Clan</span></a>
            <div className="join-positions">
              {['AI Engineer', 'Full-Stack Dev', 'UI/UX Designer', 'DevOps'].map(p => (
                <span className="position-tag" key={p}>{p}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
